import { useState,useEffect } from "react"
import { useProject } from "../Providers"
import axios from "axios"
import style from "./controlPanel.module.scss"
import ControlPanelMenu from "./ControlPanelMenu"
import MenuBus from "./MenuBus"

const ControlPanelBus = () => {
	const { user, setting, setSetting } = useProject()
	const [state, setstate] = useState([])

	const [Resions, setResions] = useState([])
	const [Companys, setCompanys] = useState([])

	useEffect(() => {
		async function getTotalPage() {
			await getcompanylist();
		}
		getTotalPage();

	}, []);	

	const getcompanylist = async () => {
		try {
			//const resp = await axios.get( `${process.env.REACT_APP_PUBLIC_API_URL}/company`	);
			const resp = await axios.get( `${process.env.REACT_APP_PUBLIC_API_URL}/userauth/list`,{
				params: {
					username:user.username,
				},
			});
			if(resp.data.data){
				let resis=[];
				resp.data.data.map(data=>{
					if( data.resion != '' && resis.filter((el) => el == data.resion).length==0){
						resis.push(data.resion)
					}
				})
				setResions(resis);

				let comps=[];
				let selmenu=[];
				resp.data.data.map(data=>{
					if(data.company != "" ){
						var val = data.resion+" : "+data.company;
						if( comps.filter((el) => el == val).length==0){
							comps.push(val)
							selmenu.push({
								region: data.resion,
								company:data.company, value:false});
						}
					}
				})
				setCompanys(comps)
				setstate(selmenu);
			}
			else{
				//setMsg(resp.data.message);
			}
		}catch (err) {
			alert(err);
		}
	};	


	const handleChange = (e,i) =>{
		var st = [];
		var val = state[i].value;
		state.map((s)=>{s.value=false; st.push(s)});
		st[i].value = !val;
		setstate(st);

		// setstate((prev) => {
		// 	for (const key in prev) prev[key] = false
		// 	return {
		// 		...prev,
		// 		[e.target.name]: !(e.target.value === "true" && true),
		// 	}
		// })

		setSetting({
			...setting,
			region : state[i].region,
			company : state[i].company,
		})
	}

	return (
		<div className={style.controlPanelOptions}>
			{user && (
				<>
				{Companys.map((resion,i)=>(
					<div className={style.controlPanelBox}>
						<button
							className={style.controlPanelOption}
							name={resion}
							value={resion}
							onClick={(e)=>handleChange(e,i)}
						>
							{resion}
						</button>
						{state[i] && state[i].value && <MenuBus setting={setting} setSetting={setSetting} 
							region={state[i].region} company={state[i].company}/>}
					</div>				
				))}
				</>
			)}
		</div>
	)
}

export default ControlPanelBus
